import { XCircleIcon } from "@heroicons/react/24/outline";
import dayjs from "dayjs";
import { FC, useCallback, useEffect, useState } from "react";
import IssueKeyModal from "../../components/operator-api-keys/IssueKeyModal";
import Button from "../../components/ui/Button";
import DeleteModal from "../../components/ui/DeleteModal";
import IconBtn from "../../components/ui/IconBtn";
import NotfoundTable from "../../components/ui/NotfoundTable";
import Status from "../../components/ui/Status";
import Table, { Row } from "../../components/ui/table";
import { IOperatorApiKey } from "../../interfaces/endpoints/IOperatorApiKey.types";
import { getOperatorApiKeys, revokeOperatorApiKey } from "../../services/OperatorApiKeys.service";

const columns = [
  "Emri", "Operatori", "Përdoruesi", "Prefiksi", "Krijuar", "Përdorur së fundi", "Statusi", "Veprimet"
];

const formatDate = (value?: string | null) => (value ? dayjs(value).format("DD.MM.YYYY HH:mm") : "—");

// Keys for operators that validate tickets from their own scanning systems.
const OperatorApiKeys: FC = () => {
  const [keys, setKeys] = useState<IOperatorApiKey[] | null>(null);
  const [failed, setFailed] = useState(false);
  const [showIssue, setShowIssue] = useState(false);

  const load = useCallback(() => {
    setFailed(false);
    getOperatorApiKeys()
      .then((response) => setKeys(response.data ?? []))
      .catch(() => setFailed(true));
  }, []);

  useEffect(load, [load]);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-end">
        <Button onClick={() => setShowIssue(true)}>Krijo çelës</Button>
      </div>
      {failed && (
        <p className="text-sm text-red">
          Lista nuk u ngarkua dot.{" "}
          <button type="button" className="underline" onClick={load}>
            Provo përsëri
          </button>
        </p>
      )}
      <Table titles={columns} style="hover" loading={!keys && !failed}>
        {keys?.map((key) => (
          <Row
            key={key.id}
            name={<span className="block max-w-[12rem] truncate" title={key.name}>{key.name}</span>}
            operator={key.operatorName ?? "—"}
            user={key.userName ?? "—"}
            prefix={<code className="text-xs">gjt_{key.keyPrefix}_…</code>}
            created={<span title={key.createdByName ?? undefined}>{formatDate(key.insertDate)}</span>}
            lastUsed={formatDate(key.lastUsedAt)}
            status={key.revokedAt
              ? <Status type="gray" name={`Anuluar ${dayjs(key.revokedAt).format("DD.MM.YYYY")}`} />
              : <Status type="green" name="Aktiv" />}
            actions={key.revokedAt ? null : (
              <DeleteModal
                params={key.id}
                handleDelete={revokeOperatorApiKey}
                title="Anulo çelësin"
                paragraph="Sistemi i operatorit nuk do të mund ta përdorë më."
                successMessage="Çelësi u anulua"
                errorMessage="Çelësi nuk u anulua"
                loadingMessage="Duke anuluar…"
                onSuccess={load}
                indicator={
                  <span title="Anulo çelësin">
                    <IconBtn className="w-6 h-6 text-red-700" ariaLabel="Anulo çelësin">
                      <XCircleIcon className="w-4 h-4" />
                    </IconBtn>
                  </span>
                }
              />
            )}
          />
        )) ?? []}
      </Table>
      {keys && !keys.length && <NotfoundTable header="Nuk ka çelësa" />}
      <IssueKeyModal show={showIssue} onClose={() => setShowIssue(false)} onIssued={load} />
    </div>
  );
};

export default OperatorApiKeys;
